import type { ReactNode } from 'react';

export const symbol_steppers: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M98-398q-33-33-33-82t33-82q33-33 82-33t82 33q33 33 33 82t-33 82q-33 33-82 33t-82-33Zm121.5-42.5Q235-456 235-480t-15.5-39.5Q204-535 180-535t-39.5 15.5Q125-504 125-480t15.5 39.5Q156-425 180-425t39.5-15.5ZM398-398q-33-33-33-82t33-82q33-33 82-33t82 33q33 33 33 82t-33 82q-33 33-82 33t-82-33Zm121.5-42.5Q535-456 535-480t-15.5-39.5Q504-535 480-535t-39.5 15.5Q425-504 425-480t15.5 39.5Q456-425 480-425t39.5-15.5ZM698-398q-33-33-33-82t33-82q33-33 82-33t82 33q33 33 33 82t-33 82q-33 33-82 33t-82-33Z"
		/>
	</svg>
);
